import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Auth.css';

const Login = () => {
  const [form, setForm] = useState({ user: '', pass: '' });
  const navigate = useNavigate();

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = e => {
    e.preventDefault();
    // Simulate login success
    localStorage.setItem('isLoggedIn', 'true');
    navigate('/home');
  };

  return (
    <div className="login-bg">
      <div className="login-center-card">
        <div className="login-logo">
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="24" cy="24" r="24" fill="#0090d0"/><path d="M24 14v20M14 24h20" stroke="#fff" strokeWidth="3" strokeLinecap="round"/></svg>
        </div>
        <h2 className="login-title">Login</h2>
        <form className="login-form" onSubmit={handleSubmit} autoComplete="off">
          <input name="user" type="text" placeholder="Phone/ Email Address" value={form.user} onChange={handleChange} required className="login-input" />
          <input name="pass" type="password" placeholder="Password" value={form.pass} onChange={handleChange} required className="login-input" />
          <button type="submit" className="login-btn">Login</button>
          <div className="login-links">
            <Link to="/forgot-password">Forgot Password?</Link>
          </div>
          <div className="login-footer">
            Do you have account?{' '}
            <Link to="/signup">Sign up</Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login; 